<!-- Start Page Title Area -->
<section class="page-title-banner">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <h2>Login</h2>
            </div>
        </div>
    </div>

    <div class="shape1"><img src="assets/img/shape1.png" alt="img"></div>
    <div class="shape2"><img src="assets/img/shape2.png" alt="img"></div>
    <div class="shape3"><img src="assets/img/shape3.png" alt="img"></div>
    <div class="shape6"><img src="assets/img/shape6.png" alt="img"></div>
    <div class="shape8 rotateme"><img src="assets/img/shape8.svg" alt="shape"></div>
    <div class="shape9"><img src="assets/img/shape9.svg" alt="shape"></div>

</section>
<!-- End Page Title Area -->

<!-- Start Login Area -->
<section class="login-area ptb-50">
    <div class="container">
        <div class="row h-100 justify-content-center align-items-center">
            <div class="col-lg-6 col-md-12">
                <div class="login-image">
                    <img src="assets/img/login.png" alt="image">
                </div>
            </div>

            <div class="col-lg-6 col-md-12">
                <div class="login-form">
                    <h3>Bienvenue!</h3>
                    <p>Veuillez vous connecter à votre compte.</p>
                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                        <div class="row">
                    
                            <!-- EMAIL -->
                            <div class="col-lg-12">
                                <div class="form-group">
                                    <input type="email" class="form-control" placeholder="Email" formControlName="email">
                                </div>
                            </div>
                    
                            <!-- CODE -->
                            <div class="col-lg-12" *ngIf="codeSent">
                                <div class="form-group">
                                    <input type="text" class="form-control" placeholder="Code de vérification" formControlName="code"
                                        maxlength="6">
                                </div>
                            </div>
                    
                            <div class="col-lg-4">
                                <div class="form-check">
                                    <input type="checkbox" class="form-check-input" id="checkme" formControlName="rememberMe">
                                    <label class="form-check-label" for="checkme">
                                        Resté connecté ?
                                    </label>
                                </div>
                            </div>
                            <div class="col-lg-4" *ngIf="codeSent">
                                <div class="form-check">
                                    <span class="click send" (click)="sendCodeByEmail()"><a>Renvoyer le code</a></span>
                                </div>
                            </div><div class="col-lg-4" *ngIf="codeSent">
                                <div class="form-check">
                                    <span class="click backToEmail" (click)="backToEmail()"><a>Modifier l'email</a></span>
                                </div>
                            </div>
                    
                            <div class="col-lg-12">
                                <button type="submit" class="btn btn-primary">
                                    {{ codeSent ? 'Valider le code' : 'Se connecter' }}
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Login Area -->
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
</ngx-spinner>